import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AuthGuard } from "../authentication/services/auth.guard.service";
import { GlobalAlertComponent } from "./components/scripts/globalalert.component";
import { GlobalAlertScheduledComponent } from "./components/scripts/scheduled.component";
import { GlobalAlertScheduledCreateEditComponent } from "./components/scripts/scheduledCreateEdit.component";

const assetsRoutes: Routes = [
  {
    path: "editorialtools",
    canActivate: [AuthGuard],
    data: {
      roles: ["Admin", "MasterDataManager", "MasterDataUser"],
    },
    children: [
      { path: "", component: GlobalAlertComponent },
      {
        path: "globalalert",
        children: [
          {
            path: "",
            component: GlobalAlertComponent,
          },
        ],
      },
      {
        path: "scheduled",
        children: [
          {
            path: "",
            component: GlobalAlertScheduledComponent,
          },
          {
            path: "create",
            component: GlobalAlertScheduledCreateEditComponent,
          },
          {
            path: "edit/:id",
            component: GlobalAlertScheduledCreateEditComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(assetsRoutes)],
  exports: [RouterModule],
})
export class EditorialToolsRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/editorialtools/editorialtools-routing.module.ts